import { CompanyDetailAndJobGroups } from '@types';
import { DetailColumn, DetailSection } from 'redesign';
import { useTranslation } from 'react-i18next';
import { EmployeeContractRequestedInfoTooltip } from './components/employee-contract-requested-info-tooltip';

export const SettingsDetail = ({ companyData }: { companyData: CompanyDetailAndJobGroups }) => {
  const { t } = useTranslation(['web-common', 'ogp-screen-specific']);
  const columns: DetailColumn[] = [
    {
      items: [
        {
          title: t('employment-type.freelancer', { ns: 'web-common' }),
          value: useTranslateYesAndNo(companyData.company.offersFreelanceWork),
        },
        {
          title: t('employment-type.tempworker', { ns: 'web-common' }),
          value: useTranslateYesAndNo(companyData.company.offersTempWork),
        },
      ],
    },
    {
      items: [
        {
          title: t('employment-type.employee', { ns: 'web-common' }),
          value: useTranslateYesAndNo(companyData.company.offersEmployeeWork),
        },
        {
          title: t('settings-detail-page.employee-contract-requested-header', {
            ns: 'ogp-screen-specific',
          }),
          value: useTranslateYesAndNo(companyData.company.requiresEmployeeContract),
          tooltip: <EmployeeContractRequestedInfoTooltip />,
        },
      ],
    },
  ];

  return <DetailSection columns={columns} />;
};

const useTranslateYesAndNo = (value: boolean) => {
  const { t } = useTranslation('web-common');
  return value ? t('confirmation-yes') : t('confirmation-no');
};
